import { useState } from "react";
import SectionTitle from "@/components/base/SectionTitle";

const faqs = [
  {
    q: "漫番志会收录哪些类型的动漫？",
    a: "漫番志是一站式卡通动漫综合门户，覆盖新番、剧场版、OVA 与经典番剧，并按热血、治愈、科幻、冒险、校园、奇幻、恋爱、悬疑等分类整理，方便你按喜好快速定位。",
  },
  {
    q: "新番和排行多久更新一次？",
    a: "新番速递随各季度档期实时更新连载进度，热门排行则根据站内口碑热度持续滚动调整，让榜单始终反映当下值得追的作品。",
  },
  {
    q: "热门排行是怎么计算出来的？",
    a: "榜单综合了作品评分、追番热度与近期讨论度等指标，提供综合榜、新番榜、剧场版榜、OVA榜与经典榜等多个维度，你可按需切换查看。",
  },
  {
    q: "剧场版和 OVA 有什么区别？",
    a: "剧场版通常指在影院上映的动画电影，片长较长、制作规模大；OVA 则指不通过影院、以光盘或网络发布的特别篇，篇幅短小但往往内容高能，深受粉丝喜爱。",
  },
  {
    q: "如何快速找到想追的作品？",
    a: "你可以使用首页或导航栏的搜索框按名称或类型检索，也可以通过页面顶部的分类导航直接进入对应栏目，每部作品都有详情页供你了解后再决定是否入坑。",
  },
  {
    q: "站内内容可以免费浏览吗？",
    a: "漫番志主要提供分类导航、排行与作品资料整理，方便你发现和了解作品，可免费浏览。建议到正版平台观看，支持创作者。",
  },
];

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="mx-auto max-w-4xl px-4 py-14 md:px-6 md:py-20">
      <SectionTitle
        eyebrow="追番指南"
        title="常见问题"
        desc="关于漫番志的使用疑问，这里都为你一一解答。"
      />

      <div className="space-y-3">
        {faqs.map((f, i) => {
          const active = open === i;
          return (
            <div
              key={i}
              className={`overflow-hidden rounded-2xl bg-background-100 ring-1 transition-colors ${
                active ? "ring-primary-500/60" : "ring-background-300/60"
              }`}
            >
              <button
                type="button"
                onClick={() => setOpen(active ? null : i)}
                aria-expanded={active}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
              >
                <h3 className="flex items-center gap-3 text-sm font-bold text-foreground-950 md:text-base">
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-xs font-bold text-background-50">
                    Q{i + 1}
                  </span>
                  {f.q}
                </h3>
                <i
                  className={`shrink-0 text-foreground-500 transition-transform duration-300 ${active ? "rotate-45 text-primary-400" : ""}`}
                >
                  {active ? <i className="ri-close-line" /> : <i className="ri-add-line" />}
                </i>
              </button>
              <div
                className={`grid transition-all duration-300 ${active ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}
              >
                <div className="overflow-hidden">
                  <p className="px-5 pb-5 pl-[4.5rem] text-sm leading-relaxed text-foreground-600">{f.a}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}